// Flip the chevrons on the accordion.
$(function() {
  $('.collapse').on('show.bs.collapse', function() {
    $(this).parent().find('.rotate').toggleClass('down');
  });
  $('.collapse').on('hide.bs.collapse', function() {
    $(this).parent().find('.rotate').toggleClass('down');
  });
});
